import { useSearchParams } from "react-router";

const useGetSessionId = () => {
  const [params] = useSearchParams();

  return params.get("pyramidsid") || "";
};

export default useGetSessionId;
